import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface FeedbackCategory {
  category_id: string;
  category_name: string;
  timestamp: string;
}

@Injectable({
  providedIn: 'root',
})
export class FeedbackCategoryService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getFeedbackCategoryList(): Observable<FeedbackCategory[]> {
    return this.http.get<FeedbackCategory[]>(
      `${this.apiUrl}/loan-review/feedback-category/category`
    );
  }
}
